module.exports = __webpack_public_path__ + "img/bg-vip-right.535ad1be.png";